<template>
    <el-pagination
        v-if="total"
        layout="total, prev, pager, next, sizes"
        :total="total"
        :page-size="pageSize"
        v-model:current-page="currentPage"
        :page-sizes="pageSizes"
        size="small"
        @update:page-size="pageSizeUpdate">
    </el-pagination>
</template>

<script setup lang="ts">
import { useSetPerPage } from "@/methods/kayttajaComposables"
import { ref, defineModel } from "vue"

const props = defineProps({ total: Number, pageSize: Number })
const currentPage = defineModel<number>("currentPage", { default: 1 })
const pageSizes = ref([10, 30, 60, 100])
const { setPerPage } = useSetPerPage()

const pageSizeUpdate = (value : number) => {
    currentPage.value = 1

    if(!value) {
        return
    }

    setPerPage(value)
}
</script>
